import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';
import { analytics } from '../../utils/analytics';
import { post } from '../apiService';

export interface CreateMarketRequest {
  name: string;
  location: string;
  nickname: string;
  tablespace: string;
  taxid: string;
  pronunciation: string;
  pacPhone?: string | null;
  resource: Record<string, string | Record<string, string>>;
  active?: boolean;
  external: boolean;
}

export interface CreateMarketResponse {
  status: string;
  marketId: string;
}

export const createMarket = async (
  body: CreateMarketRequest
): Promise<{
  data: CreateMarketResponse;
  loading: boolean;
}> => {
  const customer = getCustomerIdFromToken();
  if (!customer) {
    throw new Error('Customer Id is not available');
  }

  const url = `/resourceMatrix/market/create?customerId=${customer}`;
  let loading = true;
  try {
    const responseData = await post(
      url,
      body as unknown as Record<string, unknown>,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    loading = false;
    analytics.trackEvent('create', 'market');
    return { data: responseData as CreateMarketResponse, loading };
  } catch (error) {
    loading = false;
    throw new Error('Failed to create market');
  }
};
